import React from 'react';
import ReactDOM from 'react-dom';
import classes from './MiniPlayer.module.scss';

export default class Portal extends React.PureComponent {
  constructor(props) {
    super(props);
    this.targetEl = document.createElement('div');
    this.miniPlayerWindow = null;
  }
  componentDidMount() {
    // target needs to be miniPlayer if this is modified then Mini Player portal will not work.
    this.miniPlayerWindow = window.open('', 'miniplayer', '');
    this.copyStyles(document, this.miniPlayerWindow.document);
    this.miniPlayerWindow.document.body.appendChild(this.targetEl);
    this.addClassToElement('html', classes.miniPlayer);
    this.addClassToElement('body', classes.miniPlayer);
  }

  addClassToElement(tagName, className) {
    this.miniPlayerWindow.document.getElementsByTagName(tagName)[0].classList.add(className);
  }

  componentWillUnmount() {
    this.miniPlayerWindow.close();
    this.props.toggleMiniPlayer();
  }

  copyStyles(sourceDoc, targetDoc) {
    try {
      Array.from(sourceDoc.styleSheets).forEach((styleSheet) => {
        if (!styleSheet.href && styleSheet.cssRules && typeof styleSheet.cssRules !== 'function') {
          const newStyleEl = sourceDoc.createElement('style');
          Array.from(styleSheet.cssRules).forEach((cssRule) => {
            // write the text of each rule into the body of the style element
            if (cssRule.cssText) {
              newStyleEl.appendChild(sourceDoc.createTextNode(cssRule.cssText));
            }
          });
          targetDoc.head.appendChild(newStyleEl);
        } else if (styleSheet.href) {
          const newLinkEl = sourceDoc.createElement('link');
          newLinkEl.rel = 'stylesheet';
          newLinkEl.href = styleSheet.href;
          targetDoc.head.appendChild(newLinkEl);
        }
      });
    } catch (e) {
      console.error(e);
    }
  }

  render() {
    return ReactDOM.createPortal(this.props.children, this.targetEl);
  }
}
